export const EXAMONE_OFFICE_ID_PROD = '-OUomDKr8erb-Z7y82Mm';
export const EXAMONE_OFFICE_ID_DEV = '-OT_d0H5qZMOcmLS61cb';
/**
 * Single word - not EXAM_ONE or examone, consistent with CARESEND = 'careSend'
 *  (our existing implementation has inconsistencies)
 */
export var FulfillmentIntegrationName;
(function (FulfillmentIntegrationName) {
    FulfillmentIntegrationName["EXAMONE"] = "examOne";
    FulfillmentIntegrationName["QUEST"] = "quest";
})(FulfillmentIntegrationName || (FulfillmentIntegrationName = {}));
export var FulfillmentIntegrationType;
(function (FulfillmentIntegrationType) {
    FulfillmentIntegrationType["LAB"] = "lab";
    FulfillmentIntegrationType["MOBILE"] = "mobile";
})(FulfillmentIntegrationType || (FulfillmentIntegrationType = {}));
export var FulfillmentIntegrationNurseID;
(function (FulfillmentIntegrationNurseID) {
    FulfillmentIntegrationNurseID["EXAMONE"] = "examOneNurseID";
})(FulfillmentIntegrationNurseID || (FulfillmentIntegrationNurseID = {}));
export const fulfillmentIntegrationNurseIDToName = {
    [FulfillmentIntegrationNurseID.EXAMONE]: FulfillmentIntegrationName.EXAMONE,
};
//# sourceMappingURL=fulfillmentIntegration.js.map